module.exports = __webpack_public_path__ + "img/icon3.f0e8afbf.png";